import * as React from 'react';

type Props = {
    shouldRefresh: boolean;
    children: React.ReactNode;
    pathname: string;
};

// We need to force-refresh the page if the app version has changed.
export function RefreshingPage(props: Props): React.ReactElement {
    const [isRefreshing, setIsRefreshing] = React.useState<boolean>(false);
    const prevPathname = React.useRef(props.pathname);

    React.useEffect(() => {
        if (prevPathname.current !== props.pathname && props.shouldRefresh) {
            setIsRefreshing(true);

            // @ts-expect-error
            if (typeof window.trackJs !== 'undefined') {
                // @ts-expect-error
                window.trackJs.console.info('Refreshing page due to version change!');
            }

            location.reload();
        }
        prevPathname.current = props.pathname;
    }, [props.pathname, props.shouldRefresh]);

    // @ts-expect-error
    return isRefreshing ? null : props.children;
}
